import axios from '../request/http';

const Login = {
    // 概要
    getOutline(params) {
        return axios.get("/admin/screen/sumInfo", {params});
    },
    // 柱状图
    getBarInfo(params) {
        return axios.get("/admin/screen/monthInfo", {params});
    },
    // 用户饼状图
    getUserInfo(params) {
        return axios.get("/admin/screen/areaBusInfo", {params});
    },
    // 商户饼状图
    getMerchantInfo(params) {
        return axios.get("/admin/screen/areaOrderInfo", {params});
    },
    // 地图分布
    getMapInfo(params) {
        return axios.get("/admin/screen/provinceInfo", {params});
    },
}

export default Login;


// WEBPACK FOOTER //
// ./src/api/Login.js